import React from 'react';
import {string, number, func} from 'prop-types';
import CartOpenIcon from 'dibs-vg/dist/react/cart-open';
import styles from './mobileNavIcons.scss';
import MobileNavDisplayAmount from '../MobileNavDisplayAmount/MobileNavDisplayAmount';

// The maximum amount of cart items to display. We just append a plus sign if it's bigger than this number.
const MAX_CART_COUNT = 9;
const URL_PATH_CART = '/my/cart/';

export default function MobileNavCart(props) {
    return (
        <a className={styles.container} onClick={() => props.onClick({path: URL_PATH_CART})} >
            {!!props.cartItemCount && (
                <MobileNavDisplayAmount amount={props.cartItemCount} className={styles.count} max={MAX_CART_COUNT} />
            )}
            <CartOpenIcon className={styles.icon} />
        </a>
    );
}

MobileNavCart.propTypes = {
    className: string,
    cartItemCount: number,
    onClick: func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavIcons/MobileNavCart.jsx